import React, { useEffect, useState } from "react";
import PageTitle from "../../Module/pageTitle";
import {
  getExamListNew,
  getParentCourseNew,
  getState,
  offerPopupAdd,
  offerPopupDelete,
  offerPopupList,
  offerPopupTypes,
  setParentCourse,
  uploadPopupImg,
} from "../../Action/courseAction";
import AdminTable from "../../Component/adminTable";
import LabelField from "../../Component/labelField";
import InputField from "../../Component/inputField";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import Dropdown from "../../Component/dropdown";
import { useDispatch } from "react-redux";
import {
  length_One,
  length_Three,
  pdf_size_1MB,
  validateIsFileImageType,
  validateIsNumberOnly,
} from "../../Utils/validators";
import SubmitButton from "../../Component/SubmitButton";
import ToggleSwitchBtn from "../../Component/toggleSwitchBtn";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { validateIsFileImageTypeErrMsg } from "../../Utils/errorMsg";
import { getSubExam } from "../../Action/adminPanelAction";
import { set } from "date-fns";
import SquareCheckBox from "../../Component/SquareCheckBox";
import { Backdrop, Fade, Modal } from "@material-ui/core";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
const allTypes = [
  { _id: 1, name: "PAID" },
  { _id: 2, name: "FREE" },
  { _id: 3, name: "All" },
];

const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{6})$/;
const isValidHexColor = (value) => HEX_COLOR_REGEX.test(value);

const normalizeHexInput = (value) => {
  if (!value) return null;
  const trimmed = value.trim();
  const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
  return isValidHexColor(withHash) ? withHash : null;
};

// Type-driven visibility for the color sections.
const PRIMARY_SECONDARY_COLOR_TYPES = [
  "EXTEND",
  "UPGRADE",
  "STUDENT",
  "STUDENT 2ND",
  "SPIN WHEEL",
];
const SPINNER_COLOR_TYPE = "SPIN WHEEL";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
const ColorField = ({
  label,
  value,
  textValue,
  onPickerChange,
  onTextChange,
  onCancel,
}) => {
  return (
    <div className="d-flex align-items-center">
      <LabelField labelName={label} />
      <input
        type="color"
        value={value || "#000000"}
        onChange={(e) => onPickerChange(e.target.value)}
      />
      <input
        type="text"
        className="form-control form-control-sm ms-2"
        style={{ maxWidth: "110px" }}
        value={textValue}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder="#RRGGBB"
        maxLength={7}
      />
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary ms-2"
        onClick={onCancel}
      >
        <DeleteForeverIcon color="error" fontSize="small" />
      </button>
    </div>
  );
};

const EditPopup = () => {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [popupTypes, setPopupTypes] = useState([]);
  const [popupList, setPopupList] = useState([]);
  const [examList, setExamList] = useState([]);
  const [parentCourseList, setParentCourseList] = useState([]);
  const [parentCourseVal, setParentCourseVal] = useState("");
  const [parentCourseValShow, setParentCourseValShow] = useState("");
  const [searchPopupTypesName, setSearchPopupTypes] = useState("");
  const [popupTypesName, setPopupTypesName] = useState("");
  const [examName, setExamName] = useState("");
  const [showExamName, setShowExamName] = useState("");
  const [subExamList, setSubExamList] = useState([]);
  const [subExamName, setSubExamName] = useState("");
  const [showSubExamName, setShowSubExamName] = useState("");
  const [priorityOrder, setPriorityOrder] = useState("");
  const [headingText, setHeadingText] = useState("");
  const [popUrl, setPopUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage1, setSelectedImage1] = useState("");
  const [selectedImageView, setSelectedImageView] = useState("");
  const [selectedImageView1, setSelectedImageView1] = useState("");
  const [selectedImageMobile, setSelectedImageMobile] = useState("");
  const [selectedImageMobile1, setSelectedImageMobile1] = useState("");
  const [selectedImageMobilePrev, setSelectedImageMobilePrev] = useState("");
  const [selectedImageMobilePrev1, setSelectedImageMobilePrev1] = useState("");
  const [paidUser, setPaidUser] = useState(false);
  const [paidUserSearch, setPaidUserSearch] = useState(false);
  const [status, setStatus] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [gender, setGender] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedTypeShow, setSelectedTypeShow] = useState("");
  const [webImagePopUp, setWebImagePopUp] = useState(false);
  const [appImagePopUp, setAppImagePopUp] = useState(false);
  const [webImage, setWebImage] = useState("");
  const [appImage, setAppImage] = useState("");
  const [popupImageArr, setPopupImageArr] = useState([
    {
      webImage: "",
      appImage: "",
      webImagePreview: "",
      appImagePreview: "",
      order: "",
    },
  ]);
  // Color state — plain values, populated from the record (if present) or
  // left as "" when there's nothing to show. No submitted "default" ever.
  const [primaryColor, setPrimaryColor] = useState("");
  const [primaryColorText, setPrimaryColorText] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [secondaryColorText, setSecondaryColorText] = useState("");
  const [spinnerColor, setSpinnerColor] = useState(["", "", ""]);
  const [spinnerColorText, setSpinnerColorText] = useState(["", "", ""]);

  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      }),
    );
    dispatch(
      offerPopupTypes((res) => {
        if (res) {
          setPopupTypes(res);
        }
      }),
    );
    handleList();
  }, []);

  // Section visibility is derived from the currently loaded Type.
  const showsPrimarySecondaryColor =
    PRIMARY_SECONDARY_COLOR_TYPES.includes(popupTypesName);
  const showsSpinnerColor = popupTypesName === SPINNER_COLOR_TYPE;

  const handleList = () => {
    dispatch(
      offerPopupList({}, (res) => {
        if (res) {
          setPopupList(res);
        }
      }),
    );
  };
  const handleCancelEditMode = () => {
    setIsEdit(false);
    // fetchData()
    // dispatch(setParentCourse("isEditMode", false));
    // setSelectedType("");
  };
  const handleEdit = (value) => {
    setIsEdit(true);

    if (value?.type === "EXAM WISE" || value?.type === "CROSS SELLING") {
      setShowExamName(value?.examTypeId);
      setParentCourseValShow(value?.baseCourseId);
      setShowSubExamName(value?.subExamTypeId);
    }

    setPaidUser(value?.isPaid);
    setPopupTypesName(value?.type);
    setHeadingText(value?.text);
    setPopUrl(value?.url);
    setPriorityOrder(value?.priorityOrder);

    // ==============================
    // IMAGES
    // EXAM WISE -> images[] array
    // Other types -> flat webImage / appImage
    // SPIN WHEEL -> also webImage2 / appImage2
    // ==============================
    const emptyImageRow = {
      webImage: "",
      appImage: "",
      webImagePreview: "",
      appImagePreview: "",
      order: "",
    };

    if (value?.type === "EXAM WISE") {
      const images = Array.isArray(value?.images) ? value.images : [];
      setPopupImageArr(
        images.length > 0
          ? images.map((item) => ({
              webImage: item?.webImage || "",
              appImage: item?.appImage || "",
              webImagePreview: item?.webImage || "",
              appImagePreview: item?.appImage || "",
              order: item?.order ?? "",
            }))
          : [emptyImageRow],
      );

      setSelectedImage("");
      setSelectedImageView("");
      setSelectedImageMobile("");
      setSelectedImageMobilePrev("");
    } else {
      setPopupImageArr([emptyImageRow]);

      setSelectedImage(value?.webImage || "");
      setSelectedImageView(value?.webImage || "");
      setSelectedImageMobile(value?.appImage || "");
      setSelectedImageMobilePrev(value?.appImage || "");
    }

    if (value?.type === "SPIN WHEEL") {
      setSelectedImage1(value?.webImage2 || "");
      setSelectedImageView1(value?.webImage2 || "");
      setSelectedImageMobile1(value?.appImage2 || "");
      setSelectedImageMobilePrev1(value?.appImage2 || "");
    } else {
      setSelectedImage1("");
      setSelectedImageView1("");
      setSelectedImageMobile1("");
      setSelectedImageMobilePrev1("");
    }

    setStatus(value?.status === 1);

    setGender(value?.gender);
    setSelectedState(value?.stateId);

    if (value?.visibility === 1) {
      setSelectedTypeShow({ _id: 1, name: "PAID" });
    } else if (value?.visibility === 2) {
      setSelectedTypeShow({ _id: 2, name: "FREE" });
    } else if (value?.visibility === 3) {
      setSelectedTypeShow({ _id: 3, name: "All" });
    }

    setPrimaryColor(value?.primaryColor || "");
    setPrimaryColorText(value?.primaryColor || "");

    setSecondaryColor(value?.secondaryColor || "");
    setSecondaryColorText(value?.secondaryColor || "");

    const spinnerFromRecord = Array.isArray(value?.spinnerColor)
      ? value.spinnerColor
      : [];

    const nextSpinnerColor = [0, 1, 2].map((i) => spinnerFromRecord[i] || "");

    setSpinnerColor(nextSpinnerColor);
    setSpinnerColorText(nextSpinnerColor);
  };

  const onChangePriorityOrder = (value) => {
    if (!validateIsNumberOnly(value)) {
      setPriorityOrder(value);
    } else {
      dispatch(showErrorSnackbar("Only Numbers are allowed!"));
      return;
    }
  };
  const onPopUpChange = (value) => {
    setSearchPopupTypes(value);
  };

  const handleLogoChange = (e, index) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        if (index === 1) {
          setSelectedImageView(reader.result);
        } else if (index === 2) {
          setSelectedImageView1(reader.result);
        }
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadPopupImg(file, (resCover) => {
          if (resCover) {
            if (index === 1) {
              setSelectedImage(resCover?.fullPath);
            } else if (index === 2) {
              setSelectedImage1(resCover?.fullPath);
            }
          } else {
            dispatch(showErrorSnackbar("File Not Uploaded"));
          }
        }),
      );
    }
  };
  const handleChangeMobile = (e, index) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      if (index === 1) {
        setSelectedImageMobilePrev(reader.result);
      } else if (index === 2) {
        setSelectedImageMobilePrev1(reader.result);
      }
    };
    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (resCover) => {
        if (resCover) {
          if (index === 1) {
            setSelectedImageMobile(resCover?.fullPath);
          } else if (index === 2) {
            setSelectedImageMobile1(resCover?.fullPath);
          }
        } else {
          dispatch(showErrorSnackbar("File Not Uploaded"));
        }
      }),
    );
  };
  const changePaidUser = (event) => {
    if (event.target.checked) {
      setPaidUser(true);
    } else {
      setPaidUser(false);
    }
  };

  // --- Primary color ---
  const onPrimaryColorPickerChange = (value) => {
    setPrimaryColor(value);
    setPrimaryColorText(value);
  };
  const onPrimaryColorTextChange = (value) => {
    setPrimaryColorText(value);
    const normalized = normalizeHexInput(value);
    if (normalized) {
      setPrimaryColor(normalized);
    } else if (!value) {
      setPrimaryColor("");
    }
  };
  const handleCancelPrimaryColor = () => {
    setPrimaryColor("");
    setPrimaryColorText("");
  };

  // --- Secondary color ---
  const onSecondaryColorPickerChange = (value) => {
    setSecondaryColor(value);
    setSecondaryColorText(value);
  };
  const onSecondaryColorTextChange = (value) => {
    setSecondaryColorText(value);
    const normalized = normalizeHexInput(value);
    if (normalized) {
      setSecondaryColor(normalized);
    } else if (!value) {
      setSecondaryColor("");
    }
  };
  const handleCancelSecondaryColor = () => {
    setSecondaryColor("");
    setSecondaryColorText("");
  };

  // --- Spinner colors (3 independent swatches) ---
  const onChangeSpinnerColor = (index, value) => {
    setSpinnerColor((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };
  const onSpinnerColorPickerChange = (index, value) => {
    onChangeSpinnerColor(index, value);
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };
  const onSpinnerColorTextChange = (index, value) => {
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
    const normalized = normalizeHexInput(value);
    if (normalized) {
      onChangeSpinnerColor(index, normalized);
    } else if (!value) {
      onChangeSpinnerColor(index, "");
    }
  };
  const handleCancelSpinnerColor = (index) => {
    setSpinnerColor((prev) => {
      const updated = [...prev];
      updated[index] = "";
      return updated;
    });
    setSpinnerColorText((prev) => {
      const updated = [...prev];
      updated[index] = "";
      return updated;
    });
  };

  // const validations = () => {
  //   return (
  //     popupTypesName &&
  //     (![3, 7].includes(popupTypesName?._id) || examName) &&
  //     (![3, 7].includes(popupTypesName?._id) || parentCourseVal) &&
  //     ([3, 7].includes(popupTypesName?._id) ? popUrl?.trim() : true) &&
  //     //   headingText?.trim() &&
  //     priorityOrder &&
  //     selectedImageView &&
  //     setSelectedImageMobilePrev
  //   );
  // };
  const validations = () => {
    if (!popupTypesName) return false;
    if (!priorityOrder) return false;

    if (popupTypesName === "EXAM WISE" || popupTypesName === "CROSS SELLING") {
      if (!showExamName) return false;
      if (!parentCourseValShow) return false;
      if (!popUrl?.trim()) return false;
    }

    if (popupTypesName === "EXAM WISE") {
      return popupImageArr?.every(
        (item) => item?.webImage && item?.appImage && item?.order,
      );
    }

    if (popupTypesName === "SPIN WHEEL") {
      return (
        (selectedImage || selectedImageView) &&
        (selectedImageMobile || selectedImageMobilePrev) &&
        (selectedImage1 || selectedImageView1) &&
        (selectedImageMobile1 || selectedImageMobilePrev1)
      );
    }

    return (
      (selectedImage || selectedImageView) &&
      (selectedImageMobile || selectedImageMobilePrev)
    );
  };
  const onChangeText = (field, value) => {
    if (field === "text") {
      setHeadingText(value);
    }
    if (field === "url") {
      setPopUrl(value);
    }
  };
  const changeStatus = (event) => {
    if (event.target.checked) {
      setStatus(true);
    } else {
      setStatus(false);
    }
  };
  const onPressAddPopupImage = () => {
    setPopupImageArr((prev) => [
      ...prev,
      {
        webImage: "",
        appImage: "",
        webImagePreview: "",
        appImagePreview: "",
        order: "",
      },
    ]);
  };

  const handleClosePopupImage = (index) => {
    setPopupImageArr((prev) => prev.filter((_, i) => i !== index));
  };

  const onChangePopupImage = (index, value, key) => {
    setPopupImageArr((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [key]: value,
            }
          : item,
      ),
    );
  };
  const handlePopupWebImageChange = (e, index) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

    if (!validTypes.includes(file.type)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }

    if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPopupImageArr((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                webImagePreview: reader.result,
              }
            : item,
        ),
      );
    };

    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (response) => {
        if (response) {
          setPopupImageArr((prev) =>
            prev.map((item, i) =>
              i === index
                ? {
                    ...item,
                    webImage: response?.fullPath || "",
                  }
                : item,
            ),
          );
        }
      }),
    );
  };
  const handlePopupAppImageChange = (e, index) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

    if (!validTypes.includes(file.type)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }

    if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPopupImageArr((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                appImagePreview: reader.result,
              }
            : item,
        ),
      );
    };

    reader.readAsDataURL(file);

    dispatch(
      uploadPopupImg(file, (response) => {
        if (response) {
          setPopupImageArr((prev) =>
            prev.map((item, i) =>
              i === index
                ? {
                    ...item,
                    appImage: response?.fullPath || "",
                  }
                : item,
            ),
          );
        }
      }),
    );
  };
  const handelUpdate = (e) => {
    e.preventDefault();

    let reqBody = {
      type: popupTypesName,
      text: headingText,
      priorityOrder: priorityOrder,
      status: status ? 1 : 0,

      visibility:
        popupTypesName === "SPECIAL OFFER" || popupTypesName === "SPECIAL-OFFER"
          ? selectedTypeShow?._id
          : 3,
    };

    // ============================
    // IMAGES
    // EXAM WISE -> images[] array
    // Other types -> flat webImage / appImage
    // SPIN WHEEL -> also webImage2 / appImage2
    // ============================
    if (popupTypesName === "EXAM WISE") {
      reqBody.images = popupImageArr.map((item) => ({
        webImage: item?.webImage || "",
        appImage: item?.appImage || "",
        order: item?.order,
      }));
    } else {
      reqBody.webImage = selectedImage || selectedImageView || "";
      reqBody.appImage = selectedImageMobile || selectedImageMobilePrev || "";
    }

    if (popupTypesName === "SPIN WHEEL") {
      reqBody.webImage2 = selectedImage1 || selectedImageView1 || "";
      reqBody.appImage2 =
        selectedImageMobile1 || selectedImageMobilePrev1 || "";
    }

    // ============================
    // COLORS
    // ============================
    if (showsPrimarySecondaryColor) {
      reqBody.primaryColor = primaryColor;
      reqBody.secondaryColor = secondaryColor;
    }

    if (showsSpinnerColor) {
      reqBody.spinnerColor = spinnerColor;
    }

    // ============================
    // EXAM WISE / CROSS SELLING
    // ============================
    if (popupTypesName === "CROSS SELLING" || popupTypesName === "EXAM WISE") {
      reqBody = {
        ...reqBody,
        examTypeId: showExamName?._id,
        baseCourseId: parentCourseValShow?._id,
        url: popUrl,
        visibility: selectedTypeShow?._id,
      };
    }

    if (showSubExamName) {
      reqBody.subExamTypeId = showSubExamName._id;
    }

    // ============================
    // SPECIAL OFFER
    // ============================
    if (
      popupTypesName === "SPECIAL OFFER" ||
      popupTypesName === "SPECIAL-OFFER"
    ) {
      if (selectedState) {
        reqBody.stateId = [selectedState?._id];
      }

      if (gender) {
        reqBody.gender = gender;
      }
    }

    console.log("UPDATE PAYLOAD", reqBody);

    dispatch(
      offerPopupAdd(reqBody, async () => {
        setHeadingText("");
        setPopUrl("");
        setPriorityOrder("");
        setSelectedImageView("");
        setSelectedImageMobilePrev("");
        setSelectedImage("");
        setSelectedImageMobile("");
        setSelectedImage1("");
        setSelectedImageView1("");
        setSelectedImageMobile1("");
        setSelectedImageMobilePrev1("");

        setPopupImageArr([
          {
            webImage: "",
            appImage: "",
            webImagePreview: "",
            appImagePreview: "",
            order: "",
          },
        ]);

        setPaidUser(false);
        setStatus(false);
        setIsEdit(false);

        setPrimaryColor("");
        setPrimaryColorText("");
        setSecondaryColor("");
        setSecondaryColorText("");
        setSpinnerColor(["", "", ""]);
        setSpinnerColorText(["", "", ""]);

        fetchData();
      }),
    );
  };
  // const handelUpdate = (value) => {
  //   setPopupTypesName(value);
  // };
  const onChangeExamName = (value) => {
    setExamName(value);
    setParentCourseVal("");
    setParentCourseList([]);
    setSubExamList([]);
    setSubExamName("");
    setHeadingText("");
    setPopUrl("");
    setSelectedImageView("");
    setSelectedImageMobilePrev("");
    setSelectedType("");
    if (value) {
      dispatch(
        getSubExam(
          {
            examTypeId: value._id,
          },
          (res) => {
            if (res?.data.length > 0) {
              setSubExamList(res.data);
            } else {
              dispatch(
                getParentCourseNew(`${value._id}`, (res) => {
                  setParentCourseList(res);
                }),
              );
            }
          },
        ),
      );
    }
  };
  const onChangeSubExam = (value) => {
    setParentCourseList([]);
    setParentCourseVal("");
    setSubExamName(value);
    if (value) {
      dispatch(
        getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
          setParentCourseList(res);
        }),
      );
    }
  };
  const onChangeParentCourse = (value) => {
    setParentCourseVal(value);
  };
  const renderEditMode = () => {
    return (
      <form className=" col-md-6" onSubmit={handelUpdate}>
        <div className="d-flex mb-2 align-items-center">
          <LabelField labelName={"Type"} isRequired />
          <InputField
            placeholder={"Enter Heading Text"}
            setInputText={(value) => setPopupTypesName(value)}
            value={popupTypesName}
            disabled={true}
          />

          {/* <Dropdown
            setInputText={(value) => onPopUpChange(value)}
            value={popupTypesName}
            options={popupTypes}
            labelName="Select Type"
            Isrequired={true}
          /> */}
        </div>
        {/* <div className="d-flex mb-2 justify-content-start align-items-center">
          <ToggleSwitchBtn
            labelName={"Is Paid User"}
            getToggleval={(value) => changePaidUser(value)}
            isActive={paidUser}
            // Isrequired={true}
          />
        </div> */}
        {(popupTypesName === "EXAM WISE" ||
          popupTypesName === "CROSS SELLING") && (
          <>
            <div className="d-flex mb-2 align-items-center">
              <LabelField labelName={"Exam Name"} isRequired={true} />
              <InputField
                setInputText={(value) => onChangeExamName(value)}
                value={showExamName?.name}
                // options={examList}
                placeholder="Select Exam Name"
                disabled={true}
              />
            </div>
            {subExamList?.length > 0 ? (
              <div className=" d-flex mb-2 align-items-center">
                <LabelField labelName={"Sub Exam Name"} />
                <InputField
                  placeholder={"select Sub Exam name"}
                  setInputText={(value) => onChangeSubExam(value)}
                  value={showSubExamName?.name}
                  // options={subExamList}
                  disabled={true}
                />
              </div>
            ) : null}
            <div className="d-flex mb-2 align-items-center">
              <LabelField labelName={"Exam Stream"} isRequired={true} />
              <InputField
                setInputText={(value) => onChangeParentCourse(value)}
                value={parentCourseValShow?.name}
                // options={parentCourseList}
                placeholder="Select Exam Stream"
                disabled={true}
              />
            </div>
            <div className="d-flex align-items-center">
              <LabelField labelName={"Navigation Url"} />
              <InputField
                placeholder={"Enter Navigation Url"}
                setInputText={(value) => onChangeText("url", value)}
                value={popUrl}
                maxlength={600}
                minlength={length_One}
              />
            </div>
          </>
        )}
        {(popupTypesName === "SPECIAL OFFER" ||
          popupTypesName === "SPECIAL-OFFER") && (
          <>
            {selectedState && (
              <div className="col-md-6 d-flex mb-2 align-items-center">
                <LabelField labelName="State" />
                <InputField
                  placeholder="Select State"
                  value={selectedState?.name}
                  setInputText={(value) => setSelectedState(value)}
                  disabled
                />
              </div>
            )}

            {gender && (
              <div className="col-md-6 d-flex mb-2 align-items-center">
                <LabelField labelName="Gender" />
                <InputField
                  placeholder="Select Gender"
                  value={gender}
                  setInputText={(value) => setGender(value)}
                  disabled
                />
              </div>
            )}
            <div className="d-flex mb-2 align-items-center">
              <LabelField labelName={"Select User"} />
              <Dropdown
                setInputText={(value) => setSelectedTypeShow(value)}
                value={selectedTypeShow}
                options={allTypes}
                labelName="Select User"
                disabled
              />
            </div>
          </>
        )}

        <div className="d-flex align-items-center">
          <LabelField labelName={"Priority order"} isRequired={true} />
          <InputField
            placeholder={"Enter Priority order"}
            setInputText={(value) => onChangePriorityOrder(value)}
            value={priorityOrder}
            maxlength={length_Three}
            minlength={length_One}
          />
        </div>
        {/* <div className=" d-flex justify-content-between">
          <ImagePickerAndViewer
            isRequired
            labelName={"Image for web"}
            value={selectedImageView}
            handleChange={(e) => handleLogoChange(e, 1)}
          />
          <ImagePickerAndViewer
            isRequired
            labelName={"Image for Mobile/App"}
            value={selectedImageMobilePrev}
            handleChange={(e) => handleChangeMobile(e, 1)}
          />
        </div> */}
        {popupTypesName === "EXAM WISE" ? (
          <div className="col-md-12">
            {popupImageArr?.map((item, index) => (
              <div className="row align-items-center mb-3" key={index}>
                <div className="col-md-5">
                  <ImagePickerAndViewer
                    isRequired
                    labelName={"Image for web"}
                    value={item.webImagePreview || item.webImage}
                    handleChange={(e) => handlePopupWebImageChange(e, index)}
                  />
                </div>

                <div className="col-md-5">
                  <ImagePickerAndViewer
                    isRequired
                    labelName={"Image for Mobile/App"}
                    value={item.appImagePreview || item.appImage}
                    handleChange={(e) => handlePopupAppImageChange(e, index)}
                  />
                </div>

                <div className="col-md-2 px-0 d-flex align-items-center">
                  <lable className="me-1 fw-bold col-5 ">Order</lable>

                  <input
                    type="text"
                    className="form-control"
                    value={item.order}
                    onChange={(e) =>
                      onChangePopupImage(index, e.target.value, "order")
                    }
                  />

                  {popupImageArr.length > 1 && (
                    <HighlightOffIcon
                      className="cursor-pointer mt-2"
                      color="primary"
                      fontSize="small"
                      onClick={() => handleClosePopupImage(index)}
                    />
                  )}
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onPressAddPopupImage}
              >
                Add More
              </button>
            </div>
          </div>
        ) : (
          <>
            {" "}
            <div className=" d-flex justify-content-between">
              <ImagePickerAndViewer
                isRequired
                labelName={"Image for web"}
                value={selectedImageView}
                handleChange={(e) => handleLogoChange(e, 1)}
              />
              <ImagePickerAndViewer
                isRequired
                labelName={"Image for Mobile/App"}
                value={selectedImageMobilePrev}
                handleChange={(e) => handleChangeMobile(e, 1)}
              />
            </div>
          </>
        )}
        {popupTypesName === "SPIN WHEEL" ? (
          <div className=" d-flex justify-content-between">
            <ImagePickerAndViewer
              isRequired
              labelName={"Image for web 2"}
              value={selectedImageView1}
              handleChange={(e) => handleLogoChange(e, 2)}
            />
            <ImagePickerAndViewer
              isRequired
              labelName={"Image for Mobile/App 2"}
              value={selectedImageMobilePrev1}
              handleChange={(e) => handleChangeMobile(e, 2)}
            />
          </div>
        ) : null}
        <div className="d-flex align-items-center">
          <LabelField labelName={"Heading Text"} />
          <InputField
            placeholder={"Enter Heading Text"}
            setInputText={(value) => onChangeText("text", value)}
            value={headingText}
            maxlength={600}
            minlength={length_One}
          />
        </div>
        <div className="d-flex mb-2 justify-content-start align-items-center">
          <ToggleSwitchBtn
            labelName={"Status"}
            getToggleval={(value) => changeStatus(value)}
            isActive={status}
            // Isrequired={true}
          />
        </div>
        {showsPrimarySecondaryColor ? (
          <>
            <div className="mb-2">
              <ColorField
                label="Primary Color"
                value={primaryColor}
                textValue={primaryColorText}
                onPickerChange={onPrimaryColorPickerChange}
                onTextChange={onPrimaryColorTextChange}
                onCancel={handleCancelPrimaryColor}
              />
            </div>
            <div className="mb-2">
              <ColorField
                label="Secondary Color"
                value={secondaryColor}
                textValue={secondaryColorText}
                onPickerChange={onSecondaryColorPickerChange}
                onTextChange={onSecondaryColorTextChange}
                onCancel={handleCancelSecondaryColor}
              />
            </div>
          </>
        ) : null}
        {showsSpinnerColor && (
          <div className="mb-2">
            <LabelField labelName={"Spinner Color"} />
            <div className="d-flex align-items-center flex-wrap">
              {spinnerColor.map((color, index) => (
                <div className="me-4 mb-2" key={index}>
                  <ColorField
                    label={`Color ${index + 1}`}
                    value={color}
                    textValue={spinnerColorText[index]}
                    onPickerChange={(value) =>
                      onSpinnerColorPickerChange(index, value)
                    }
                    onTextChange={(value) =>
                      onSpinnerColorTextChange(index, value)
                    }
                    onCancel={() => handleCancelSpinnerColor(index)}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        <SubmitButton
          name="Update"
          validations={!validations()}
          onClick={handelUpdate}
        />
      </form>
    );
  };
  const handleDelete = (value) => {
    dispatch(
      offerPopupDelete(value?._id, (res) => {
        if (res) handleList();
      }),
    );
  };

  const changePaidUserSearch = (event) => {
    if (event.target.checked) {
      setPaidUserSearch(true);
    } else {
      setPaidUserSearch(false);
    }
  };
  const fetchData = () => {
    let postData = {};
    if (searchPopupTypesName) postData.type = searchPopupTypesName.type;
    if (examName) postData.examTypeId = examName._id;
    if (subExamName) postData.subExamTypeId = subExamName._id;
    if (parentCourseVal) postData.baseCourseId = parentCourseVal._id;
    if (selectedType) postData.visibility = selectedType._id;
    dispatch(
      offerPopupList(postData, (res) => {
        if (res) {
          setPopupList(res);
        }
      }),
    );
  };
  const handelSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  const previewWebImage = (value) => {
    setWebImagePopUp(true);
    setWebImage(value?.webImage);
  };
  const previewAppImage = (value) => {
    setAppImagePopUp(true);
    setAppImage(value?.appImage);
  };

  const handlePopUpImage = () => {
    setWebImagePopUp(false);
    setAppImagePopUp(false);
    setWebImage("");
    setAppImage("");
  };

  const renderListMode = () => {
    return (
      <>
        <div className="row">
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Type"} />
            <Dropdown
              setInputText={(value) => onPopUpChange(value)}
              value={searchPopupTypesName}
              options={popupTypes}
              labelName="Select Type"
              type="type"
            />
          </div>
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Exam Name"} />
            <Dropdown
              setInputText={(value) => onChangeExamName(value)}
              // defaultValue={examName?._id}
              options={examList}
              labelName="Select Exam Name"
              value={examName}
            />
          </div>
          {subExamList?.length > 0 ? (
            <div className="col-md-4 d-flex mb-2 align-items-center">
              <LabelField labelName={"Sub Exam Name"} />
              <Dropdown
                labelName={"Sub Exam Name"}
                placeholder={"select Sub Exam name"}
                setInputText={(value) => onChangeSubExam(value)}
                value={subExamName}
                options={subExamList}
              />
            </div>
          ) : null}
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Exam Stream"} />
            <Dropdown
              setInputText={(value) => onChangeParentCourse(value)}
              // defaultValue={parentCourseVal?._id}
              options={parentCourseList}
              labelName="Select Exam Stream"
              value={parentCourseVal}
            />
          </div>
          {/* <div className="col-md-3">
            <div className="rounded-2 p-2 d-flex just align-items-center">
              <LabelField labelName={"Is Paid User"} />
              <ToggleSwitchBtn
                getToggleval={(value) => changePaidUserSearch(value)}
                isActive={paidUserSearch}
              />
            </div>
          </div> */}
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Select User"} />
            <Dropdown
              setInputText={(value) => setSelectedType(value)}
              value={selectedType}
              options={allTypes}
              labelName="Select User"
            />
          </div>

          <div className=" col-md-12 text-end pe-4">
            <button
              type="submit"
              className="btn btn-primary submitbtn"
              onClick={handelSearch}
            >
              Search
            </button>
          </div>
        </div>

        <div className="col-12">
          {/* <AdminTable
            tableData={popupList ? popupList : []}
            pagename={"allPopUp"}
            tableHead={[
              "S.N",
              "Exam Name",
              "Exam Stream",
              "Sub-Exam Name",
              "Web Image",
              "App Image",
              "State",
              "Gender",
              "Type",
              "Text",
              "Priority Order",
              "Actions",
            ]}
            handleEdit={(value) => handleEdit(value)}
            handleDelete={(value) => handleDelete(value)}
            edit={true}
          /> */}
          <table className="w-100 mt-2">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Exam Name</th>
                <th>Exam Stream</th>
                <th>Sub-Exam Name</th>
                <th>Web Image</th>
                <th>App Image</th>
                <th>State</th>
                <th>Gender</th>
                <th>Type</th>
                <th>Text</th>
                <th>Priority Order</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {popupList?.length > 0 ? (
                popupList?.map((data, index) => {
                  // EXAM WISE -> images[0], other types -> flat keys
                  const isExamWise = data?.type === "EXAM WISE";
                  const rowWebImage = isExamWise
                    ? data?.images?.[0]?.webImage
                    : data?.webImage;
                  const rowAppImage = isExamWise
                    ? data?.images?.[0]?.appImage
                    : data?.appImage;

                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{data?.examTypeId?.name || "-"}</td>
                      <td>{data?.baseCourseId?.name || "-"}</td>
                      <td>{data?.subExamTypeId?.name || "-"}</td>
                      <td>
                        {rowWebImage ? (
                          <div
                            onClick={() =>
                              previewWebImage({
                                webImage: rowWebImage,
                              })
                            }
                            style={{
                              position: "relative",
                              width: "40px",
                              height: "40px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={rowWebImage}
                              alt=""
                              style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              className="eye-overlay"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.5)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                opacity: 0,
                                transition: "opacity 0.2s ease",
                              }}
                            >
                              <RemoveRedEyeIcon />
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {rowAppImage ? (
                          <div
                            onClick={() =>
                              previewAppImage({
                                appImage: rowAppImage,
                              })
                            }
                            style={{
                              position: "relative",
                              width: "40px",
                              height: "40px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={rowAppImage}
                              alt=""
                              style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              className="eye-overlay-app"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.5)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                opacity: 0,
                                transition: "opacity 0.2s ease",
                              }}
                            >
                              <RemoveRedEyeIcon />
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{data?.stateId?.name || "-"}</td>
                      <td>{data?.gender || "-"}</td>
                      <td>{data?.type || "-"}</td>
                      <td>{data?.text || "-"}</td>
                      <td>{data?.priorityOrder || "-"}</td>
                      <td>
                        {!isEdit && (
                          <>
                            <button
                              onClick={() => handleEdit(data)}
                              className="text-primary border border-0 bg-transparent me-1 fw-semibold"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDelete(data)}
                              className="text-danger border border-0 bg-transparent fw-semibold"
                            >
                              Delete
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>No Data Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="contentBox">
        <PageTitle
          name={"EDIT / DELETE POPUP"}
          isEditMode={isEdit}
          onClick={handleCancelEditMode}
        />
        <div className="row formDiv contentScrollbar m-0">
          <div className="col-12 formWidth pt-3">
            {!isEdit ? renderListMode() : renderEditMode()}
          </div>
        </div>
      </div>
      {(webImagePopUp || appImagePopUp) && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="model"
          open={webImagePopUp || appImagePopUp}
          onClose={handlePopUpImage}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={webImagePopUp || appImagePopUp}>
            <div className="modeldivChat p-md-4 bgwhite position-relative">
              <div>
                <div className="position-absolute end-0 top-0 pe-2 pt-2">
                  <ClearOutlinedIcon
                    className="text-primary bg-primary-subtle rounded-circle cursor"
                    onClick={handlePopUpImage}
                    style={{
                      padding: "1px",
                    }}
                  />
                </div>
                <img
                  src={webImage || appImage}
                  alt={"Image"}
                  style={{
                    maxWidth: "500px",
                    maxHeight: "500px",
                    // aspectRatio: "2/3",
                    width: "100%",
                    height: "auto",
                  }}
                />
              </div>
            </div>
          </Fade>
        </Modal>
      )}
    </div>
  );
};

export default EditPopup;
